import { render, staticRenderFns } from "./SVGMascot.vue?vue&type=template&id=f09d46d0&scoped=true&"
import script from "./SVGMascot.vue?vue&type=script&lang=js&"
export * from "./SVGMascot.vue?vue&type=script&lang=js&"
import style0 from "./SVGMascot.vue?vue&type=style&index=0&id=f09d46d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09d46d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f09d46d0')) {
      api.createRecord('f09d46d0', component.options)
    } else {
      api.reload('f09d46d0', component.options)
    }
    module.hot.accept("./SVGMascot.vue?vue&type=template&id=f09d46d0&scoped=true&", function () {
      api.rerender('f09d46d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/SVGMascot.vue"
export default component.exports